import { render, staticRenderFns } from "./TheHeaderMobileMenu.vue?vue&type=template&id=18048bd0&"
import script from "./TheHeaderMobileMenu.vue?vue&type=script&lang=js&"
export * from "./TheHeaderMobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IClose: require('/opt/build/repo/components/svg/Close.vue').default,ILogoMono: require('/opt/build/repo/components/svg/LogoMono.vue').default,SocialLinks: require('/opt/build/repo/components/SocialLinks.vue').default})
